if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.container = this.closest('[data-section-type]');
        this.shareButton = this.querySelector('[data-share-button]');
        this.tooltip = this.querySelector('tooltip-component');
      }

      connectedCallback() {
        if (!this.shareButton) return;

        this.urlToShare = this.shareButton.dataset.shareLink || document.location.href;

        if (navigator.share) {
          this.shareButton.addEventListener('click', () => {
            navigator.share({url: this.urlToShare, title: document.title});
          });
        } else {
          this.shareButton.addEventListener('click', this.copyToClipboard.bind(this));
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.urlToShare).then(() => {
          if (typeof this.tooltip?.addPinEvent === 'function') {
            this.tooltip.addPinEvent();
          }

          setTimeout(() => window.theme.closeAllTooltips(), 1500);
        });
      }

      updateUrl(url) {
        if (url) {
          this.urlToShare = url;
        }
      }
    }
  );
}
